(function () {
	'use strict';

	angular.module('qbePortal').directive('addressValidation', function () {

		return {
			require: 'ngModel',
			restrict: 'A',
			link: function (scope, elm, attrs, ctrl) {

				//important- this handler is to manage selection from type-ahead
				scope.$on('type-ahead-value-received', function (value) {
					if (scope.$eval(attrs.addressValidation) == true) {
						//false mark valid
						ctrl.$setValidity('address', true);
					} else {
						//false marks invalid
						ctrl.$setValidity('address', false);
					}
				})


				function validateAddress(ngModelValue) {
					// //console.log(scope.$eval(attrs.addressValidation));
					if (scope.$eval(attrs.addressValidation) == 'true') {
						//false mark valid
						ctrl.$setValidity('address', true);
					} else {
						//false marks invalid
						ctrl.$setValidity('address', false);
					}

					return ngModelValue;
				}

				ctrl.$parsers.push(validateAddress);
			}
		};
	});
})();
